import React from 'react';
import { Package, MapPin, Printer, Plus, AlertCircle } from 'lucide-react';

function ActionButtons({ selectedDate, setActiveComponent, hasActivePickup }) {
  function handleAddDelivery() {
    if (!hasActivePickup) {
      return; // Do nothing if no active pickup
    }
    setActiveComponent('Entrega');
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-12">
      <div className="flex flex-col items-center text-center mb-8">
        <Package className="w-16 h-16 text-slate-300 mb-4" />
        <h3 className="text-lg font-bold text-slate-900 font-montserrat mb-2">
          No hay entregas para esta fecha
        </h3>
        <p className="text-sm text-slate-600 font-montserrat max-w-md">
          No se encontraron entregas ni recojos para el{' '}
          {new Date(selectedDate).toLocaleDateString('es-PE', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
          })}
        </p>
      </div>

      {/* Warning message if no active pickup */}
      {!hasActivePickup && (
        <div className="max-w-3xl mx-auto mb-6">
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-amber-900 font-montserrat">
                Recojo requerido
              </p>
              <p className="text-xs text-amber-700 font-montserrat mt-1">
                Debes agregar un recojo antes de poder crear entregas.
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
        {/* Agregar Entrega - Disabled if no active pickup */}
        <button
          onClick={handleAddDelivery}
          disabled={!hasActivePickup}
          className={`flex flex-col items-center gap-3 p-6 rounded-xl transition-all duration-200 group relative ${
            hasActivePickup
              ? 'bg-gradient-to-br from-[#B1336E] to-[#E6B43C] hover:shadow-lg text-white cursor-pointer'
              : 'bg-slate-100 text-slate-400 cursor-not-allowed opacity-60'
          }`}
        >
          <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-transform ${
            hasActivePickup 
              ? 'bg-white/20 group-hover:scale-110' 
              : 'bg-slate-200'
          }`}>
            <Plus className="w-6 h-6" />
          </div>
          <div>
            <p className="font-bold font-montserrat">Agregar Entrega</p>
            <p className={`text-xs mt-1 font-montserrat ${
              hasActivePickup ? 'text-white/80' : 'text-slate-500'
            }`}>
              {hasActivePickup ? 'Crear nueva entrega' : 'Requiere recojo activo'}
            </p>
          </div>
          
          {/* Tooltip on hover when disabled */}
          {!hasActivePickup && (
            <span className="absolute -top-12 left-1/2 transform -translate-x-1/2 px-3 py-2 bg-slate-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none font-montserrat z-50 shadow-lg">
              Primero agrega un recojo
            </span>
          )}
        </button>

        {/* Agregar Recojo */}
        <button
          onClick={() => setActiveComponent('Recojo')}
          className="flex flex-col items-center gap-3 p-6 bg-gradient-to-br from-[#E6B43C] to-[#67A43C] hover:shadow-lg text-white rounded-xl transition-all duration-200 group"
        >
          <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
            <MapPin className="w-6 h-6" />
          </div>
          <div>
            <p className="font-bold font-montserrat">Agregar Recojo</p>
            <p className="text-xs text-white/80 font-montserrat mt-1">
              Programar recojo
            </p>
          </div>
        </button>

        {/* Imprimir Rótulos */}
        <button
          onClick={() => setActiveComponent('Print')}
          className="flex flex-col items-center gap-3 p-6 bg-gradient-to-br from-[#67A43C] to-[#B1336E] hover:shadow-lg text-white rounded-xl transition-all duration-200 group"
        >
          <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
            <Printer className="w-6 h-6" />
          </div>
          <div>
            <p className="font-bold font-montserrat">Imprimir Rótulos</p>
            <p className="text-xs text-white/80 font-montserrat mt-1">
              Generar etiquetas
            </p>
          </div>
        </button>
      </div>
    </div>
  );
}

export default ActionButtons;